export const BookingStatus = {
  checkedIn: 'checkedIn',
  confirmed: 'confirmed',
  unconfirmed: 'unconfirmed',
  online: 'online',
  locked: 'locked',
};
